import React from 'react';
import { graphql } from 'react-relay';

import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';
import { disabledColor, infoColor, unit } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import UnstyledButton from '@zego/components/button/UnstyledButton';
import CustomerService from '@zego/components/CustomerService';
import Hero from '@zego/components/HomepageHero';
import Marketing from '@zego/components/Marketing';
import ProductSelector from '@zego/components/ProductSelector';
import ScrollToElement from '@zego/components/ScrollToElement';
import SectionDisplay from '@zego/components/SectionDisplay';
import SubItemsSection from '@zego/components/SubItemsSection';

import WhyZegoEs from './components/WhyZegoEs';

import One from '@zego/static/svgs/One.svg';
import Three from '@zego/static/svgs/Three.svg';
import Two from '@zego/static/svgs/Two.svg';

const HOW_IT_WORKS_CONTENT = {
  title: '¿Cómo funciona?',
  imageWidth: 90,
  items: [
    {
      title: 'Elige tu seguro',
      description:
        'Ofrecemos seguros flexibles que se adaptan a tus necesidades. Para empezar, elige el que mejor encaje contigo.',
      image: One,
    },
    {
      title: 'Haz las cuentas',
      description: (
        <RegularText css={{ textAlign: 'center' }}>
          Calcula tu precio en nuestra web o a través de nuestro equipo
          dedicado y empieza a pagar por uso.{' '}
          <strong>Ni más, ni menos.</strong>
        </RegularText>
      ),
      image: Two,
    },
    {
      title: 'Todo listo',
      description:
        'Una vez que aceptes el precio que te ofrecemos solo tendrás que integrarte con nosotros.',
      image: Three,
    },
  ],
};

const HomepageEs = ({ viewer }) => {
  return (
    <BaseLayout
      viewer={viewer}
      title="Seguros para flotas comerciales y de VTC | Zego España"
      description="Zego ofrece seguros inteligentes cuyo precio depende del uso real de tu flota. Además, te ayudamos a mejorar la forma de conducir de tus conductores."
    >
      <Hero
        title={<>El seguro que se adapta a tus necesidades.</>}
        subtitle="Somos Zego. Ofrecemos seguros flexibles que se adaptan a ti."
      >
        <ProductSelector viewer={viewer} />
        <Spacer height={unit(6)} />
        <ScrollToElement
          selector="#register-interest"
          render={scroll => (
            <UnstyledButton
              css={{
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.7)',
                cursor: 'pointer',
              }}
              onClick={event => {
                event.preventDefault();
                scroll();
              }}
            >
              ¿Necesitas otro tipo de seguro?{' '}
              <span
                css={{
                  color: infoColor(5),
                  textDecoration: 'underline',
                }}
              >
                Déjanos&nbsp;tu&nbsp;email
              </span>
            </UnstyledButton>
          )}
        />
      </Hero>

      <Marketing country="es" />
      <SectionDisplay css={{ backgroundColor: disabledColor(2) }}>
        <SubItemsSection {...HOW_IT_WORKS_CONTENT} />
      </SectionDisplay>
      <WhyZegoEs />
      <CustomerService />
    </BaseLayout>
  );
};

export default withData(HomepageEs, {
  query: graphql`
    query HomepageEsQuery($country: String!) {
      viewer {
        ...BaseLayout_viewer @arguments(country: $country)
        ...ProductSelector_viewer @arguments(country: $country)
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
